import { render, staticRenderFns } from "./CoopBaseInfo.vue?vue&type=template&id=2451d1bb&scoped=true&"
import script from "./CoopBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CoopBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CoopBaseInfo.vue?vue&type=style&index=0&id=2451d1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451d1bb",
  null
  
)

export default component.exports